import { jsx as _jsx } from "react/jsx-runtime";
import { ToggleInput } from '@bos/ui';
import { useController } from 'react-hook-form';
export const ToggleField = ({ control, name, registerOptions, ...toggleInputProps }) => {
    const { field, fieldState } = useController({
        control,
        name,
        defaultValue: false,
        ...registerOptions,
    });
    const { value, onChange, ref, ...restField } = field;
    const handleChange = (newValue) => field.onChange(newValue);
    const checkedValue = value ?? false;
    return (_jsx(ToggleInput, { ...toggleInputProps, ...restField, error: fieldState.error?.message, checked: checkedValue, onChange: handleChange }));
};
